import { ReactNode, useCallback, useRef, useState } from "react";
import { AlertContext } from "./AlertContext";
import { AppAlert } from "./AlertTypes";
import { AlertSnackbar } from "./AlertSnackbar";

interface AlertProviderProps {
    children: ReactNode;
}

export const AlertProvider = ({ children }: AlertProviderProps) => {
    const [alerts, setAlerts] = useState<AppAlert[]>([]);
    const idRef = useRef(0);

    const showAlert = useCallback(
        (
            message: string,
            severity: AppAlert["severity"] = "info",
            duration = 3000
        ) => {
            const id = ++idRef.current;

            setAlerts((prev) => [
                ...prev,
                { id, message, severity, duration },
            ]);
        },
        []
    );

    const hideAlert = useCallback((id: number) => {
        setAlerts((prev) => prev.filter((alert) => alert.id !== id));
    }, []);

    return (
        <AlertContext.Provider value={{ showAlert, hideAlert }}>
            {children}
            <AlertSnackbar alerts={alerts} onClose={hideAlert} />
        </AlertContext.Provider>
    );
};
